import { Component, Input, OnInit } from '@angular/core';
import { HomepageService } from '../../../../homepage/services/homepage.service';
import { EventsService, UtilService, VariablesService } from '../../../../shared/services';


@Component({
  selector: 'app-story-promo-banner',
  templateUrl: './story-promo-banner.component.html',
  styleUrls: ['./story-promo-banner.component.scss']
})
export class StoryPromoBannerComponent implements OnInit {
  @Input() config;
  trendingstory: any;
  constructor(
    private util: UtilService,
    public vars: VariablesService,
    public events: EventsService,
    private homepageService: HomepageService
  ) { }

  ngOnInit(): void {
    this.getTrendingStory();
  }

  redirect(data) {
    const payload = {
      eventName: 'story_nudge',
      page_name: this.vars.pageName || 'home',
    };
    this.events.sendSystemEvent(payload).subscribe(_ => _);
    this.util.router.navigate(['/stories/' + data]);
  }

  getTrendingStory() {
    this.homepageService.getTrendingStory().subscribe(res => {
      this.trendingstory = res;
    });
  }
}